// 右の1段目を読み終えた位置から、左紹介も同じ距離だけスクロールする。
export function initWorkScroll(root, lenis, desktop, { scroller = window, Observer = ResizeObserver } = {}) {
  const features = [...root.querySelectorAll('.feature')];
  const list = root.querySelector('.work-list');
  const stage = root.querySelector('.feature-stage');
  const items = [...list.querySelectorAll('article')];
  if (!features.length || !items.length) return () => {};
  let hold = 0;
  let height = 0;
  let distance = 0;
  let span;
  let active = false;

  const update = () => {
    if (!active) return;
    const viewportTop = scroller === window ? 0 : scroller.getBoundingClientRect().top;
    const offset = viewportTop - list.getBoundingClientRect().top;
    const position = Math.max(0, Math.min(offset - hold, distance));
    stage.scrollTop = position;
    features.forEach((feature, index) => {
      const visible = index * height < position + height && (index + 1) * height > position;
      if (feature.inert === !visible) return;
      feature.inert = !visible;
      if (visible) feature.removeAttribute('aria-hidden');
      else feature.setAttribute('aria-hidden', 'true');
    });
  };
  const reset = () => {
    active = false;
    stage.scrollTop = 0;
    span = undefined;
    root.classList.remove('is-synced');
    root.style.removeProperty('--work-span');
    features.forEach((feature) => {
      feature.inert = false;
      feature.removeAttribute('aria-hidden');
    });
  };
  const refresh = () => {
    if (!desktop.matches) {
      if (active) { reset(); lenis.resize(); }
      return;
    }
    const wasActive = active;
    active = true;
    root.classList.add('is-synced');
    const firstTop = list.getBoundingClientRect().top;
    const rows = [];
    items.forEach((item) => {
      const top = item.getBoundingClientRect().top - firstTop;
      if (!rows.length || top - rows.at(-1) > 1) rows.push(top);
    });
    hold = rows[1] ?? items[0].getBoundingClientRect().height;
    height = stage.getBoundingClientRect().height;
    distance = (features.length - 1) * height;
    // 右一覧の下端が画面下端に届いたら、左右の区画を一緒に流す。
    const nextSpan = Math.max(list.getBoundingClientRect().height - height, hold + distance);
    if (!wasActive || nextSpan !== span) {
      span = nextSpan;
      root.style.setProperty('--work-span', `${span}px`);
      lenis.resize();
    }
    update();
  };
  const observer = new Observer(refresh);
  items.forEach((item) => observer.observe(item));
  observer.observe(stage);
  lenis.on('scroll', update);
  desktop.addEventListener('change', refresh);
  window.addEventListener('resize', refresh);
  window.addEventListener('load', refresh);
  refresh();

  return () => {
    observer.disconnect();
    lenis.off('scroll', update);
    desktop.removeEventListener('change', refresh);
    window.removeEventListener('resize', refresh);
    window.removeEventListener('load', refresh);
    reset();
  };
}
